import {ExpandedChecksList} from '@github-ui/mergebox/components/sections/checks/ExpandedChecksList'
import type {StatusCheck, StatusRollup} from '@github-ui/mergebox/page-data/payloads/status-checks'
import {MergeBoxExpandable} from '@github-ui/mergebox/components/sections/common/MergeBoxExpandable'
import styles from './ChecksSection.module.css'
import type {MergeBoxPullRequest} from '../use-validated-checks-data'

interface ChecksSectionProps {
  statusChecks: StatusCheck[]
  mergeBoxPullRequest: MergeBoxPullRequest
  statusRollup: StatusRollup
}

export function ChecksSection({statusChecks, mergeBoxPullRequest, statusRollup}: ChecksSectionProps) {
  return (
    <MergeBoxExpandable isExpanded wrapperClassName={styles.wrapper} contentClassName={styles.content}>
      <ExpandedChecksList
        statusChecks={statusChecks}
        statusRollupSummary={statusRollup.summary}
        pullRequestId={mergeBoxPullRequest.id}
        mergeBoxUserPreferences={mergeBoxPullRequest.mergeBoxUserPreferences}
        viewerCanUseCopilotCodingAgent={mergeBoxPullRequest.viewerCanUseCopilotCodingAgent}
        viewerHasCEOrCBAccess={mergeBoxPullRequest.viewerHasCEOrCBAccess}
      />
    </MergeBoxExpandable>
  )
}
